import { BASE_URL, CURRENCY_CODE } from '../config';
import { deserializeCart, serializeCart } from '../helper/addToCart';
import { apiFetch } from '../helper/apiClient';
export { applyCoupon } from './coupon';

export async function paymentIntent(totalPrice, cart, orderId=null) {
    try {
        const response = await apiFetch(
            'products/payment', 
            {
                method: 'POST',
                body: JSON.stringify({
                    amount: totalPrice,
                    currency: CURRENCY_CODE,
                    cart: serializeCart(cart),
                    order_id:orderId
                })
            },
            { auth: true }
        );      

        const responseBody = await response.json();
        console.log(response.status);


        if (response.status === 200) {
            return responseBody;  // Successful purchase response, containing details like clientSecret
        } else {
            throw new Error(responseBody.detail || responseBody.error || 'Failed to complete purchase');
        }


    } catch (error) {
        console.error("Error: " + error);
    }
}

export async function buy(
  totalPrice,
  items,
  paymentMethod,
  customerInfo,
  shippingPaid,
  coupon = ""
) {
  console.log(items);
  console.log(paymentMethod);
  console.log(customerInfo);
  console.log(shippingPaid);
  console.log(coupon);
  console.log(totalPrice);
  try {
    const result = await apiFetch(
      "products/buy",
      {
        method: "POST",
        body: JSON.stringify({
          order_metadata: {
            payment_method: paymentMethod,
            shipping_amount: shippingPaid,
            total_price: totalPrice,
            code: coupon,
          },
          cart: serializeCart(items),
          customer_info: {
            tiktok_name: customerInfo.tiktokName,
            email: customerInfo.email,
            first_name: customerInfo.firstName,
            last_name: customerInfo.lastName,
            address: customerInfo.shippingAddress,
            suburb: customerInfo.shippingSuburb,
            postcode: customerInfo.shippingPostcode,
            state: customerInfo.shippingState,
            country: customerInfo.shippingCountry,
          },
        }),
      },
      { auth: true }
    );

    const res = await result.json();

    if (!result.ok) {
      return {
        success: false,
        error: res.detail || res.error || "Failed to create order. Please check your details and try again.",
      };
    }

    return {
      success: true,
      email: customerInfo.email,
      orderId: res.order_id
    };

  } catch (err) {
    return {
      success: false,
      error: "Network error. Please try again.",
    };
  }
}